//Create Member by Super or Admin
import * as React from 'react';
import { useEffect, useState } from "react";
import { Box, Container, Grid, Typography, TextField, Button, MenuItem, Snackbar, Select, InputLabel, Alert } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import StepProgress from './StepProgress';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function FormComponent() {

  // State variables for form fields
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    dob: "",
    city: "",
    district: "",
    state: "",
    pincode:"",
    identityProofType: "",
    identityProofNumber: "",
    panCard: "",
    panCardNumber: "",
    email: "",
    occupation: "",
    address: "",
    familyDetails: "",
    maritalStatus: "",
    star: "",
    raasi: "",
    kootram: "",
    kuladeivam: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const userRole = localStorage.getItem("userRole"); 
// Get role from state or props

  const requestBody = {
    method: "POST",  // Include this field
    ...formData,  // Spread form data
};


  const handleSubmit = async (e) => {
    console.log(formData);
    console.log("OnSubmit Function");

    e.preventDefault();
    if (!validateForm()) {
      console.log("Form validation failed");
      return;
  }
  
  console.log("Validation Passed. Sending API request...");
    
   

    try {
        // eslint-disable-next-line 
        const response = await fetch(
            "https://script.google.com/macros/s/AKfycbzyIIbvGkEeN64eNJR6Fa2KewqjIr8Xu4Y-zby3MtM-CdVW34-V1WVBBRteRPyTesx8Ag/exec",
            {
                method: "POST",
                mode: "no-cors", // Prevents CORS issues
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            }
        );
        console.log("Data sent successfully");
     
        setOpenSnackbar(true);
        // Clear the form after submission
        setFormData({
            firstName: "",
            lastName: "",
            dob: "",
            mobile: "",
            city: "",
            district: "",
            state: "",
            pincode: "",
            identityProofType: "", 
            identityProofNumber: "",
            panCard:"",
            panCardNumber:  "",
        });
        // Redirect after success (Superuser navigates to "manageusers , Admin navigates to "manageuser")
       setTimeout(() => {
        if (user?.role === "superuser") {
            navigate("/manageusers"); 
        } else if (user?.role === "admin") {
            navigate("/manageuser"); 
        }
    }, 2000);
    } catch (error) {
        console.error("Error sending data:", error);
        alert("Failed to send data");
        
    }
};

const handleCloseSnackbar = () => {
  setOpenSnackbar(false);
}

  const [errors, setErrors] = useState({});
  
      const validateForm = () => {
        let newErrors = {};
      
        if (!formData.firstName) {
          console.log("first name issue");
          newErrors.firstName = " ";  
        }
        if (!formData.lastName) {
          console.log("last name issue");
          newErrors.Last_Name = " ";  
        }
        if (!formData.dob) {
          console.log("dob  issue");
          newErrors.DOB = " ";  
        }else {
          const selectedDate = new Date(formData.dob);
          const today = new Date();
          
          // Remove time part for accurate date comparison
          today.setHours(0, 0, 0, 0);
          selectedDate.setHours(0, 0, 0, 0);
      
          if (selectedDate >= today) {  
              newErrors.DOB = "Date of Birth must be in the past"; // Now today is also invalid
          }
      }
        if (!formData.mobile) {
          console.log("mobile issue");
          newErrors.Mobile_Number = " ";  
        }
        if (!formData.city) {
          console.log("city issue");
          newErrors.City = " ";  
        }
        if (!formData.district) {
          console.log("district issue");
          newErrors.district = " ";  
        }
        if (!formData.state) {
          console.log("state issue");
          newErrors.state = " ";  
        }
        if (!formData.pincode) {
          console.log("pincode issue");
          newErrors.Pincode = " ";  
        }
        if (formData.panCardNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panCardNumber)) {
          newErrors.panCardNumber = "Enter a valid PAN Number (Eg: ABCDE1234F)";
        }
       
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
  };


   // Handles radio button changes
 const handleRadioChange = (e) => {
  setFormData({ ...formData, identityProofType: e.target.value });
};

   // Handles radio button changes
   const handlestatusChange = (e) => {
    setFormData({ ...formData, maritalStatus: e.target.value });
  };

  const handlePanChange = (e) => {
    setFormData({ ...formData, panCard: e.target.value, panCardNumber: e.target.value === "Yes" ? "" : formData.panCardNumber });
};


  useEffect(() => {
    // Get mobile number & user type from localStorage
    const mobile = localStorage.getItem("mobile");
    const userType = localStorage.getItem("user_type");

    if (!mobile || !userType) {
      console.error("Mobile number or user type not found in localStorage");
      return;
    }

  }, []);
  


const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
  "Dindigul" , "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
  "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
  "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", "Tirunelveli", "Tirupathi",
  "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"
];
const states = ["Tamil Nadu"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px"  }}>
      <Container>
        <StepProgress />
        <Typography variant="h5" sx={{ fontWeight: "400", color: "#E52029", mb: 2, fontSize: "20px", textAlign: "center" }}>
          Kindly fill the details and pay 2000 to get member ID
        </Typography>
        <form onSubmit={handleSubmit} > 
        <Grid item xs={12} md={6}>
          <Box
            component="form"
            sx={{
              backgroundColor: "#f8f9e9",
              padding: 4,
              borderRadius: "8px",
              borderColors: "#CEC35E",
              boxShadow: 3,
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <TextField
                fullWidth
                label="First Name"
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                error={!!errors.firstName}  
                helperText={errors.firstName || ""} 
                sx={{ mb: 2 }}
                required
              />
              <TextField
                fullWidth
                label="Last Name"
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                error={!!errors.Last_Name}  
                helperText={errors.Last_Name || ""} 
                sx={{ mb: 2 }}
                required
              />
              <TextField
                fullWidth
                label="Date of Birth"
                type="date"
                name="dob"
                value={formData.dob ? new Date(formData.dob).toISOString().split("T")[0] : ""}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                error={!!errors.DOB}  
                helperText={errors.DOB || ""} 
                sx={{ mb: 2 }}
                required
              />
              <TextField
                fullWidth
                label="Mobile Number"
                placeholder="Your Mobile Number"
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                error={!!errors.Mobile_Number}  
                helperText={errors.Mobile_Number || " "} 
                sx={{ mb: 2 }}
                required
              />
              <TextField
                fullWidth
                label="City"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                error={!!errors.City}  
                helperText={errors.City || ""} 
                sx={{ my: 2 }}
                required
              />
              <FormControl fullWidth required>
              <InputLabel>District</InputLabel>
              <Select 
              name="district" 
              value={formData.district} 
              onChange={handleChange}
              error={!!errors.district}  
                helperText={errors.district || ""} 
                required
              sx={{ textAlign: "left" , my: 2 }} >
              {districts.map((district, index) => (
               <MenuItem key={index} value={district}>
                {district}
                 </MenuItem>
                 ))}
               </Select>
              </FormControl>

              <FormControl fullWidth  required>
               <InputLabel>State</InputLabel>
                  <Select name="state" value={formData.state} 
                  onChange={handleChange} 
                  error={!!errors.state}  
                helperText={errors.state|| ""} 
                required
                sx={{ textAlign: "left", my: 2 }} >
                {states.map((state, index) => (
                <MenuItem key={index} value={state}>
                {state}
                </MenuItem>
                 ))}
                 </Select>
                 </FormControl>

              <TextField
                fullWidth
                label="Pincode"
                placeholder="Pincode"
                type="number"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                inputProps={{ maxLength: 10, pattern: "[0-6]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6)}
                error={!!errors.Pincode}  
                helperText={errors.Pincode || ""} 
                sx={{ my: 2 }}
                required
              />
             
              
              <TextField
                fullWidth
              
                label="Occupation"
                placeholder="Occupation"
                type="text"
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
                sx={{ my: 2 }}
                inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
              />
              <TextField
                fullWidth
             
                label="Address"
                placeholder="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                sx={{ my: 2 }}
                inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
              />
              <TextField
                fullWidth
               
                label="Email ID"
                placeholder="Enter you Email ID"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                sx={{ my: 2 }}
                inputProps={{ maxLength: 50 }}
              />
              <TextField
                fullWidth
              
                label="Family Details"
                placeholder="Family Details"
                name="familyDetails"
                value={formData.familyDetails}
                onChange={handleChange}
                sx={{ my: 2 }}
              />
              
              <FormControl fullWidth sx={{ textAlign: "left", my: 2 }}>
                <InputLabel id="marital-status-label" shrink
                sx={{
                  backgroundColor: "#f8f9e9",
                  px: 1,
                  transform: "translate(14px, -6px) scale(0.75)",
                 }}
                  >Star</InputLabel>
                <Select
                  labelId="marital-status-label"
                  name="star"
                  value={formData.star}
                  onChange={handleChange}
                  sx={{backgroundColor: "#f8f9e9"}}
                  displayEmpty
                >
                  <MenuItem value="Aswini">Aswini</MenuItem>
                  <MenuItem value="Bharani">Bharani</MenuItem>
                  <MenuItem value="Karthigai">Karthigai</MenuItem>
                  <MenuItem value="Mirgasheersham">Mirgasheersham</MenuItem>
                  <MenuItem value="Thiruvaathirai">Thiruvaathirai</MenuItem>
                  <MenuItem value="Punarpoosam">Punarpoosam</MenuItem>
                  <MenuItem value="Aayilyam">Aayilyam</MenuItem>
                  <MenuItem value="Makam">Makam</MenuItem>
                  <MenuItem value="Pooram">Pooram</MenuItem>
                  <MenuItem value="Uthiram">Uthiram</MenuItem>
                  <MenuItem value="Hastham">Hastham</MenuItem>
                  <MenuItem value="Chithirai">Chithirai</MenuItem>
                  <MenuItem value="Swaathi">Swaathi</MenuItem>
                  <MenuItem value="Visaakam">Visaakam</MenuItem>
                  <MenuItem value="Anusham">Anusham</MenuItem>
                  <MenuItem value="Kettai">Kettai</MenuItem>
                  <MenuItem value="Moolam">Moolam</MenuItem>
                  <MenuItem value="Pooraadam">Pooraadam</MenuItem>
                  <MenuItem value="Uthiraadam">Uthiraadam</MenuItem>
                  <MenuItem value="Thiruvonam">Thiruvonam</MenuItem>
                  <MenuItem value="Avittam">Avittam</MenuItem>
                  <MenuItem value="Chathayam/Sadayam">Chathayam/Sadayam</MenuItem>
                  <MenuItem value="Poorattathi">Poorattathi</MenuItem>
                  <MenuItem value="Uthirattathi">Uthirattathi</MenuItem>
                  <MenuItem value="Revathi">Revathi</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth variant="outlined" sx={{ textAlign: "left", my: 2 }}>
                <InputLabel id="occupation-label" shrink 
                sx={{
                  backgroundColor: "#f8f9e9",
                  px: 1,
                  transform: "translate(14px, -6px) scale(0.75)",
                }}>Raasi</InputLabel>
                <Select
                  labelId="occupation-label"
                  name="raasi"
                  value={formData.raasi}
                  onChange={handleChange}
                  sx={{backgroundColor: "#f8f9e9" }}
                >
                  <MenuItem value="Mesham">Mesham</MenuItem>
                  <MenuItem value="Risabham">Risabham</MenuItem>
                  <MenuItem value="Mithunam">Mithunam</MenuItem>
                  <MenuItem value="Kadagam">Kadagam</MenuItem>
                  <MenuItem value="Simmam">Simmam</MenuItem>
                  <MenuItem value="Kanni">Kanni</MenuItem>
                  <MenuItem value="Thulam">Thulam</MenuItem>
                  <MenuItem value="Viruchigam">Viruchigam</MenuItem>
                  <MenuItem value="Dhanushu">Dhanushu</MenuItem>
                  <MenuItem value="Magaram">Magaram</MenuItem>
                  <MenuItem value="Kumbham">Kumbham</MenuItem>
                  <MenuItem value="Meenam">Meenam</MenuItem>
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label="Kootram"
                placeholder="Kootram"
                name="kootram"
                value={formData.kootram}
                onChange={handleChange}
                sx={{ my: 2 }}
                inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
              />
              <TextField
                fullWidth
                label="Kuladeivam"
                placeholder="Kuladeivam"
                name="kuladeivam"
                value={formData.kuladeivam}
                onChange={handleChange}
                sx={{ my: 2 }}
                inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
              />
                 {/* PAN Requirement Selection */}
        <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
  <Grid container spacing={2} alignItems="center">
    
    {/* PAN Number Label */}
    <Grid item xs={2}>
    <FormLabel sx={{ whiteSpace: "nowrap" }}  >Marital Status</FormLabel>

    </Grid>

    {/* PAN Required Radio Buttons */}
    <Grid item xs={12} sm={10}>
      <FormControl component="fieldset">
        <RadioGroup row name="maritalStatus" value={formData.maritalStatus} onChange={handlestatusChange}>
          <FormControlLabel value="Yes" control={<Radio />} label="Single" />
          <FormControlLabel value="No" control={<Radio />} label="Married" />
        </RadioGroup>
      </FormControl>
    </Grid>

  </Grid>
  </Box>
  <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
   <Grid container spacing={2} alignItems="center">
    {/* ID Proof Label & Radio Buttons in One Row */}
    <Grid item xs={2}>
       <FormLabel sx={{ whiteSpace: "nowrap" }} >ID Proof </FormLabel>

      </Grid>
      <Grid item xs={12} sm={10}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            name="identityProofType"
            value={formData.identityProofType}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="aadhaar"
              control={<Radio sx={{ color: "gray" }} />}
              label="Aadhaar"
            />
            <FormControlLabel
              value="license"
              control={<Radio sx={{ color: "grey" }} />}
              label="License"
            />
            <FormControlLabel
              value="None"
              control={<Radio sx={{ color: "grey" }} />}
              label="None"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      {/* Aadhar Number Field */}
      {formData.identityProofType === "aadhaar" && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Aadhaar Number"
            type="text"
            name="identityProofNumber"
            value={formData.identityProofNumber}
            onChange={handleChange}
            error={
              formData.identityProofNumber && !/^\d{12}$/.test(formData.identityProofNumber)
            }
            helperText={
              formData.identityProofNumber && !/^\d{12}$/.test(formData.identityProofNumber)
                ? "Enter a valid Aadhaar Number (must be 12 digits)"
                : ""
            }
            inputProps={{ maxLength: 12 }}
            placeholder="Enter Aadhaar Number"
            onInput={(e) =>
              (e.target.value = e.target.value.replace(/\D/g, "").slice(0, 12))
            }
       
          />
          
        </Grid>
      )}

      {/* License Number Field */}
      {formData.identityProofType === "license" && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="License Number"
            type="text"
            name="identityProofNumber"
            value={formData.identityProofNumber}
            onChange={handleChange}
                    error={
                      formData.identityProofNumber && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                    }
                    helperText={
                      formData.identityProofNumber && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                        ? "Enter a valid License Number (e.g., AB1234567890123)."
                        : ""
                    }
            inputProps={{ maxLength: 15 }}
            placeholder="Enter License Number"
            onInput={(e) =>
              (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
            }
          
          />
        </Grid>
      )}
    </Grid>
    </Box>

   
     
    
        {/* PAN Requirement Selection */}
        <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
  <Grid container spacing={3} alignItems="center">
    
    {/* PAN Number Label */}
    <Grid item xs={2}>
    <FormLabel sx={{ whiteSpace: "nowrap" }} >PAN Card</FormLabel>
    </Grid>

    {/* PAN Required Radio Buttons */}
    <Grid item xs={12} sm={10}>
      <FormControl component="fieldset">
        <RadioGroup row name="panCard" value={formData.panCard} onChange={handlePanChange}>
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
          <FormControlLabel value="Later" control={<Radio />} label="Later" />
        </RadioGroup>
      </FormControl>
    </Grid>

  </Grid>

  {/* PAN Number Field (Only if "Yes" is selected) */}
  {formData.panCard === "Yes" && (
    <Grid container spacing={2}>
     
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="PAN Number"
          placeholder="Enter PAN Number"
          name="panCardNumber"
          value={formData.panCardNumber}
          onChange={handleChange}
                  error={!!errors.panCardNumber}  
                  helperText={errors.panCardNumber || ""}
          inputProps={{ maxLength: 10  }}
          onInput={(e) =>(e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))
          }
        />
      </Grid>
    </Grid>
  )}
</Box>
</div>
  </Box>

          <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
    <Grid item>
        <Button type="submit" 
      
        variant="contained" 
        onClick={handleSubmit}
        fullWidth style={{ backgroundColor: "green", color: "white" }}>
            Create Member 
        </Button>
    </Grid>
    <Grid item>
        
        </Grid>
        </Grid>
        </Grid>
        </form>
      </Container>
       {/* Snackbar Alert */}
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }} >
            <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
                          Member Created Successfully!
                      </Alert>
                  </Snackbar>
    </Box>
  );
}